import { Back, Power0, TweenMax } from 'gsap';
import { Star } from '../../Animations/Star';
import { HighlightEffect } from '../HighlightEffect';
import { UIButton } from './UIButton';
import Point = PIXI.Point;

export default class RoundedIconButton extends UIButton {
    public get highlighted() {
        return this.highlight && this.highlight.alpha > 0;
    }

    private notification: PIXI.Sprite;
    private icon: PIXI.Sprite;
    private readonly highlight: HighlightEffect;

    public get width() {
        return this.bg.width;
    }

    public get height() {
        return this.bg.height;
    }

    constructor(iconId: string, scale: number = 1) {
        super('mapui/navi-button-bg');
        this.scale.set(scale);
        this.originalScale.set(scale, scale);

        this.highlight = new HighlightEffect({ scale: scale * 0.8, duration: 2 });

        const icon = new PIXI.Sprite(PIXI.utils.TextureCache[iconId]);
        icon.anchor.set(0.5);
        this.icon = icon;

        const notification = (this.notification = new PIXI.Sprite(
            PIXI.utils.TextureCache['mapui/notification-badge']
        ));
        notification.anchor.set(0.5);
        notification.x = icon.width * 0.35;
        notification.y = -icon.height * 0.35;
        notification.alpha = 0;
        this.interactive = false;
        this.addChild(icon, notification);
        this.alpha = 0;
    }

    public appear(tween: boolean = false) {
        this.interactive = true;
        if (!tween) {
            this.alpha = 1;
            return;
        }
        this.scale.set(0);

        TweenMax.to(this, 0.2, { delay: 0.3, alpha: 1 });
        TweenMax.to(this.scale, 0.8, {
            x: this.originalScale.x,
            y: this.originalScale.y,
            delay: 0.3,
            ease: Back.easeOut,
        });
        const star = new Star(2);
        this.addChild(star.sprite);
        star.play();
    }

    public showNotification() {
        this.notification.alpha = 1;
    }

    public hideNotification() {
        this.notification.alpha = 0;
    }

    public callAttention() {
        TweenMax.to(this.scale, 0.4, {
            x: 1.2 * this.originalScale.x,
            y: 1.2 * this.originalScale.y,
            delay: 1.3,
            ease: Back.easeOut,
            repeat: 1,
            yoyo: true,
            onComplete: () => {
                this.callAttention();
            },
        });
    }

    public stopCallAttention() {
        TweenMax.killTweensOf(this.scale);
        const { x, y } = this.originalScale;
        this.scale.set(x, y);
    }

    public swapButton(id: string) {
        this.icon.texture = PIXI.utils.TextureCache[id];
        if (id.includes('shop-gift')) {
            this.highlightButton();
            this.showNotification();
        } else {
            TweenMax.killTweensOf(this);
            TweenMax.killTweensOf(this.icon);
            TweenMax.killTweensOf(this.icon.scale);
            this.hideNotification();
            this.highlight.cleanUp();
            this.removeChild(this.highlight);
            this.bg.alpha = 1;
            this.scale.set(this.originalScale.x, this.originalScale.y);
            this.icon.scale.set(1);
        }
    }

    public highlightButton() {
        const scale = new Point(this.scale.x, this.scale.y);
        this.icon.scale.set(0);
        this.bg.alpha = 0;
        this.addChildAt(this.highlight, 0);
        this.highlight.appear();
        TweenMax.to(this.icon, 0.2, { alpha: 1 });
        TweenMax.to(this.icon.scale, 0.5, {
            x: scale.x * 0.9,
            y: scale.y * 0.9,
            ease: Back.easeOut,
            onComplete: () => {
                if (this.parent) {
                    TweenMax.to(this.icon.scale, 0.7, {
                        x: scale.x * 0.8,
                        y: scale.y * 0.8,
                        yoyo: true,
                        repeat: -1,
                        ease: Power0.easeNone,
                    });
                }
            },
        });
    }
}
